var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3699 13.6512L17.8699 36.1512C17.7393 36.282 17.5842 36.3857 17.4135 36.4565C17.2428 36.5272 17.0598 36.5637 16.875 36.5637C16.6902 36.5637 16.5072 36.5272 16.3365 36.4565C16.1658 36.3857 16.0107 36.282 15.8801 36.1512L6.03632 26.3075C5.77245 26.0436 5.62421 25.6857 5.62421 25.3125C5.62421 24.9394 5.77245 24.5815 6.03632 24.3176C6.30019 24.0538 6.65807 23.9055 7.03124 23.9055C7.40441 23.9055 7.76229 24.0538 8.02616 24.3176L16.875 33.1682L38.3801 11.6614C38.6439 11.3975 39.0018 11.2493 39.375 11.2493C39.7482 11.2493 40.106 11.3975 40.3699 11.6614C40.6338 11.9252 40.782 12.2831 40.782 12.6563C40.782 13.0295 40.6338 13.3874 40.3699 13.6512Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.c604650f05dce69b13432cde6973c184.svg";
export { ForwardRef as ReactComponent };